// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__44F1h","content":"LoadingAlert_content__1tB0p"};